/* ============================================================
   定型キーホルダー エディタ
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     テンプレートデータ（Illustrator SVGから抽出）
     viewBox: [x, y, w, h] — マスターSVG座標
     printAreaPath: 画像クリップ領域
     cutLinePath: カットライン表示
     hole: 穴位置 { cx, cy, r }
     center: 印刷領域中心
     size: 印刷領域サイズ
  ---------------------------------------------------------- */
  var TEMPLATES = [
    {
      id: 'flower', name: '花形', size: '53×58mm',
      viewBox: [148, 207, 148, 178],
      printAreaPath: 'M212.42,366.73c-4.38,0-8.62-1.56-11.95-4.4l-2.93-2.5c-5.26-4.48-11.67-7.14-18.55-7.68l-3.84-.31c-9.07-.72-16.18-7.83-16.9-16.9l-.31-3.84c-.55-6.88-3.21-13.3-7.68-18.55l-2.5-2.93c-5.9-6.92-5.9-16.98,0-23.9l2.5-2.93c4.48-5.25,7.13-11.67,7.68-18.55l.31-3.84c.72-9.07,7.83-16.18,16.9-16.9l3.84-.31c6.88-.55,13.29-3.21,18.55-7.68l2.93-2.5c3.33-2.84,7.57-4.4,11.95-4.4s8.62,1.56,11.95,4.4l2.93,2.5c5.25,4.48,11.67,7.14,18.55,7.68l3.84.31c9.07.72,16.18,7.83,16.9,16.9l.31,3.84c.55,6.88,3.21,13.3,7.68,18.55l2.5,2.93c5.9,6.92,5.9,16.98,0,23.9l-2.5,2.93c-4.48,5.25-7.13,11.67-7.68,18.55l-.31,3.84c-.72,9.07-7.83,16.18-16.9,16.9l-3.84.31c-6.88.55-13.3,3.21-18.55,7.68l-2.93,2.5c-3.33,2.84-7.57,4.4-11.95,4.4Z',
      cutLinePath: 'M282.47,314.21l-2.5,2.93c-3.48,4.09-5.59,9.17-6.01,14.52l-.31,3.84c-1,12.49-10.91,22.41-23.4,23.4l-3.84.31c-5.35.43-10.43,2.53-14.52,6.01l-2.93,2.5c-9.54,8.13-23.56,8.13-33.09,0l-2.93-2.5c-4.09-3.48-9.17-5.59-14.52-6.01l-3.84-.31c-12.49-1-22.41-10.91-23.4-23.4l-.31-3.84c-.43-5.35-2.53-10.43-6.01-14.52l-2.5-2.93c-8.13-9.54-8.13-23.56,0-33.09l2.5-2.93c3.48-4.09,5.59-9.17,6.01-14.52l.31-3.84c1-12.49,10.91-22.41,23.4-23.4l3.84-.31c5.35-.43,10.43-2.53,14.52-6.01l2.93-2.5c1.27-1.09,2.63-2.02,4.04-2.81,2.13-1.19,3.1-3.66,2.71-6.07-.08-.51-.13-1.04-.13-1.58,0-5.84,5.05-10.51,11.02-9.86,4.57.49,8.28,4.22,8.76,8.79.1.95.07,1.87-.09,2.75-.41,2.37.63,4.79,2.73,5.96,1.41.79,2.77,1.73,4.04,2.81l2.93,2.5c4.09,3.48,9.17,5.59,14.52,6.01l3.84.31c12.49,1,22.41,10.91,23.4,23.4l.31,3.84c.43,5.35,2.53,10.43,6.01,14.52l2.5,2.93c8.13,9.54,8.13,23.56,0,33.09ZM212.42,212.91c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25,4.25-1.9,4.25-4.25-1.9-4.25-4.25-4.25Z',
      hole: { cx: 212.42, cy: 217.16, r: 4.25 },
      center: { x: 212.42, y: 295 }, areaW: 118, areaH: 124
    },
    {
      id: 'circle', name: '円形', size: '50×55mm',
      viewBox: [310, 213, 158, 168],
      printAreaPath: 'M389.04,363.62c-35.17,0-63.78-28.61-63.78-63.78s28.61-63.78,63.78-63.78,63.78,28.61,63.78,63.78-28.61,63.78-63.78,63.78Z',
      cutLinePath: 'M398.78,226.77c.18-.93.23-1.9.13-2.9-.46-4.6-4.19-8.35-8.78-8.84-5.97-.63-11.01,4.03-11.01,9.86,0,.6.05,1.19.16,1.76.28,1.58-.71,3.09-2.3,3.37-34.52,5.95-60.58,36.93-58.71,73.52,1.84,35.98,30.92,65.13,66.9,67.06,40.82,2.18,74.74-30.4,74.74-70.76,0-34.96-25.46-64.07-58.81-69.82-1.54-.26-2.61-1.72-2.32-3.25ZM392.57,224.9c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 389.03, cy: 224.9, r: 3.54 },
      center: { x: 389.04, y: 299.84 }, areaW: 127.56, areaH: 127.56
    },
    {
      id: 'square', name: '正方形', size: '45×50mm',
      viewBox: [474, 213, 138, 162],
      printAreaPath: 'M486.38,241.14h113.39v113.39h-113.39z',
      cutLinePath: 'M604.02,234.06h-49.71c-1.04,0-1.85-.97-1.6-1.98.28-1.13.37-2.34.21-3.59-.57-4.54-4.3-8.19-8.85-8.64-5.93-.58-10.92,4.06-10.92,9.87,0,.78.09,1.53.26,2.26.25,1.05-.49,2.07-1.58,2.07h-49.71c-1.57,0-2.83,1.27-2.83,2.83v121.89c0,1.57,1.27,2.83,2.83,2.83h121.89c1.57,0,2.83-1.27,2.83-2.83v-121.89c0-1.57-1.27-2.83-2.83-2.83ZM546.62,229.73c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 543.08, cy: 229.73, r: 3.54 },
      center: { x: 543.07, y: 297.83 }, areaW: 113.39, areaH: 113.39
    },
    {
      id: 'heart', name: 'ハート形', size: '55×45mm',
      viewBox: [630, 232, 162, 145],
      printAreaPath: 'M711.97,256.34c-1.83,1.13-3.98,1.79-6.29,1.79-.08,0-.15,0-.22-.01-.08,0-.15.01-.22.01-2.31,0-4.46-.66-6.29-1.79-.75-.46-2.42-2.01-2.42-2.01-6.29-5.98-14.3-8.19-22.47-8.74-.09,0-.18-.02-.26-.02-.22-.01-.45-.02-.67-.03-11.49-.59-23.33,4.04-31.18,14.52-5.09,6.79-7.28,14.19-7.33,21.62,0,.11,0,.21,0,.32,0,.24,0,.49,0,.73.04,5.2,1.14,10.27,3.03,15.13,2.72,7.26,7.08,14.12,12.31,19.96,15.4,17.22,36.24,29.45,55.41,41.95.03-.02.07-.04.1-.06.03.02.07.04.1.06,19.17-12.5,40.01-24.73,55.41-41.95,5.23-5.84,9.58-12.7,12.31-19.96,1.89-4.86,3-9.93,3.03-15.13,0-.24,0-.49,0-.73,0-.11,0-.21,0-.32-.06-7.43-2.25-14.83-7.33-21.62-7.85-10.48-19.69-15.12-31.18-14.52-.22,0-.45.01-.67.03-.09,0-.18.02-.26.02-8.17.55-16.18,2.76-22.47,8.74,0,0-1.67,1.55-2.42,2.01Z',
      cutLinePath: 'M774.43,255.82c-1.18-1.58-2.47-3.06-3.83-4.44l-.08-.07c-.64-.64-1.71-1.65-2.38-2.25,0,0,0,0-.01-.01-7.84-6.84-17.87-10.65-28.6-10.65-.79,0-1.58.03-2.36.07-6.85.3-13.36,2.16-19.12,5.34-1.41.78-3.24.27-3.96-1.17-1.63-3.24-4.98-5.46-8.85-5.46s-7.22,2.22-8.85,5.46c-.72,1.44-2.55,1.95-3.96,1.17-5.76-3.18-12.27-5.04-19.12-5.34-.78-.04-1.57-.07-2.36-.07-10.74,0-20.77,3.81-28.6,10.65,0,0,0,0-.01.01-.68.59-1.75,1.61-2.38,2.25l-.08.07c-1.36,1.38-2.64,2.86-3.83,4.44-5.86,7.82-8.81,16.84-8.75,26.47-.04,6.78,1.47,13.67,4.49,20.55,2.95,6.93,7.25,13.69,12.65,19.72,13.94,15.58,31.72,27.01,48.92,38.06,2.65,1.7,5.29,3.4,7.9,5.1,1.21.79,2.59,1.16,3.98,1.14,1.38.02,2.77-.35,3.98-1.14,2.61-1.7,5.25-3.4,7.9-5.1,17.2-11.05,34.99-22.48,48.92-38.06,5.4-6.04,9.71-12.8,12.65-19.72,3.02-6.87,4.53-13.76,4.49-20.55.06-9.63-2.89-18.65-8.75-26.47ZM708.77,247.08c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 705.23, cy: 247.08, r: 3.54 },
      center: { x: 706, y: 305 }, areaW: 138, areaH: 104
    },
    {
      id: 'window', name: '窓形', size: '45×55mm',
      viewBox: [198, 444, 149, 178],
      printAreaPath: 'M221.56,597.5c-.78,0-1.42-.64-1.42-1.42v-83.62c0-27.65,19.9-50.74,46.12-55.71-.04.37-.06.75-.06,1.14,0,5.86,4.77,10.63,10.63,10.63s10.63-4.77,10.63-10.63c0-.38-.02-.76-.06-1.14,26.23,4.97,46.12,28.06,46.12,55.71v83.62c0,.78-.64,1.42-1.42,1.42h-110.55Z',
      cutLinePath: 'M332.11,604.59h-110.55c-4.7,0-8.5-3.81-8.5-8.5v-83.62c0-35.22,28.56-63.78,63.78-63.78h0c35.22,0,63.78,28.56,63.78,63.78v83.62c0,4.7-3.81,8.5-8.5,8.5ZM280.38,461.44c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 276.84, cy: 461.44, r: 3.54 },
      center: { x: 276.84, y: 532 }, areaW: 110, areaH: 138
    },
    {
      id: 'diamond', name: '菱形', size: '40×75mm',
      viewBox: [348, 431, 129, 274],
      printAreaPath: 'M410.18,642.98c-4.96,0-9.46-2.93-11.47-7.47l-35.97-81.53c-2.86-6.49-2.86-13.92,0-20.41l35.97-81.53c.36-.81.79-1.57,1.3-2.27,1.33,4.46,5.39,7.7,10.17,7.7s8.84-3.25,10.17-7.7c.5.7.94,1.46,1.3,2.27l35.97,81.53c2.86,6.49,2.86,13.92,0,20.41l-35.97,81.53c-2,4.54-6.5,7.47-11.47,7.47Z',
      cutLinePath: 'M428.13,449.17l35.97,81.53c3.67,8.32,3.67,17.81,0,26.13l-35.97,81.53c-3.14,7.11-10.18,11.7-17.95,11.7h0c-7.77,0-14.81-4.59-17.95-11.7l-35.97-81.53c-3.67-8.32-3.67-17.81,0-26.13l35.97-81.53c3.14-7.11,10.18-11.7,17.95-11.7h0c7.77,0,14.81,4.59,17.95,11.7ZM410.18,442.78c-1.96,0-3.54,1.7-3.54,3.8s1.59,3.8,3.54,3.8,3.54-1.7,3.54-3.8-1.59-3.8-3.54-3.8Z',
      hole: { cx: 410.18, cy: 446.58, r: 3.8 },
      center: { x: 410.18, y: 548 }, areaW: 82, areaH: 193
    },
    {
      id: 'rectangle', name: '長方形', size: '40×55mm',
      viewBox: [474, 445, 133, 177],
      printAreaPath: 'M490.63,600.12v-129.78c.46.06.94.09,1.42.09,5.86,0,10.63-4.77,10.63-10.63,0-.48-.03-.95-.09-1.42h87.26v141.73h-99.21Z',
      cutLinePath: 'M594.1,607.21h-107.72c-1.57,0-2.83-1.27-2.83-2.83v-150.24c0-1.57,1.27-2.83,2.83-2.83h107.72c1.57,0,2.83,1.27,2.83,2.83v150.24c0,1.57-1.27,2.83-2.83,2.83ZM492.05,463.35c1.96,0,3.54-1.59,3.54-3.54s-1.59-3.54-3.54-3.54c-1.96,0-3.54,1.59-3.54,3.54s1.59,3.54,3.54,3.54Z',
      hole: { cx: 492.05, cy: 459.81, r: 3.54 },
      center: { x: 540, y: 531 }, areaW: 107, areaH: 140
    },
    {
      id: 'stick', name: 'スティック形', size: '23×80mm',
      viewBox: [614, 412, 84, 250],
      printAreaPath: 'M629.8,640.72v-200.64c.46.06.94.09,1.42.09,5.86,0,10.63-4.77,10.63-10.63,0-.48-.03-.95-.09-1.42h39.07v212.6h-51.02Z',
      cutLinePath: 'M685.08,647.8h-59.53c-1.57,0-2.83-1.27-2.83-2.83v-221.1c0-1.57,1.27-2.83,2.83-2.83h59.53c1.57,0,2.83,1.27,2.83,2.83v221.1c0,1.57-1.27,2.83-2.83,2.83ZM631.22,425.99c-1.96,0-3.54,1.59-3.54,3.54s1.59,3.54,3.54,3.54,3.54-1.59,3.54-3.54-1.59-3.54-3.54-3.54Z',
      hole: { cx: 631.22, cy: 429.53, r: 3.54 },
      center: { x: 655, y: 537 }, areaW: 52, areaH: 210
    }
  ];

  /* ----------------------------------------------------------
     初期化
  ---------------------------------------------------------- */
  function init(root) {
    var isModalMode = root.dataset.mode === 'modal';
    var printMode   = root.dataset.print || '片面';
    var svgEl        = root.querySelector('.caf-kh-std__svg-el');
    var svgWrap      = root.querySelector('.caf-kh-std__svg-wrap');
    var uploadGuide  = root.querySelector('.caf-kh-std__upload-guide');
    var fileInput    = root.querySelector('.caf-kh-std__file-input');
    var controls     = root.querySelector('.caf-kh-std__controls');
    var strip        = root.querySelector('.caf-kh-std__strip');
    var sliderScale  = root.querySelector('.caf-kh-std__slider-scale');
    var sliderX      = root.querySelector('.caf-kh-std__slider-x');
    var sliderY      = root.querySelector('.caf-kh-std__slider-y');
    var sliderRotate = root.querySelector('.caf-kh-std__slider-rotate');
    var valScale     = root.querySelector('.caf-kh-std__val-scale');
    var valX         = root.querySelector('.caf-kh-std__val-x');
    var valY         = root.querySelector('.caf-kh-std__val-y');
    var valRotate    = root.querySelector('.caf-kh-std__val-rotate');
    var btnUpload    = root.querySelector('.caf-kh-std__btn--upload');
    var btnReset     = root.querySelector('.caf-kh-std__btn--reset');
    var btnConfirm   = root.querySelector('.caf-kh-std__btn--confirm');
    var btnRedo      = root.querySelector('.caf-kh-std__btn--redo');
    var btnAddBack    = root.querySelector('.caf-kh-std__btn--add-back');
    var btnRemoveBack = root.querySelector('.caf-kh-std__btn--remove-back');
    var btnSkipBack   = root.querySelector('.caf-kh-std__btn--skip-back');
    var doneCanvasBackWrap = root.querySelector('.caf-kh-std__done-canvas-back-wrap');
    var doneBackSide       = root.querySelector('.caf-kh-std__done-side--back');
    var currentPhase = 'front';
    var frontCanvas = null, backCanvas = null;
    var frontImgUrl = '', frontNatW = 0, frontNatH = 0;
    var frontState  = { tx: 0, ty: 0, scale: 1, rotate: 0 };
    var backImgUrl  = '', backNatW  = 0, backNatH  = 0;
    var backState   = { tx: 0, ty: 0, scale: 1, rotate: 0 };
    var sizeBadge      = root.querySelector('.caf-kh-std__size-badge');
    var bodyEl         = root.querySelector('.caf-kh-std__body');
    var donePanel      = root.querySelector('.caf-kh-std__done');
    var doneCanvasWrap = root.querySelector('.caf-kh-std__done-canvas-wrap');
    var doneAttachStrip   = root.querySelector('.caf-kh-std__done-attach-strip');
    var doneAttachLabel   = root.querySelector('.caf-kh-std__done-attach-selected');
    var btnOrder          = root.querySelector('.caf-kh-std__btn--order');
    var deliveryOptions   = root.querySelectorAll('.caf-kh-std__delivery-label');
    var qtyValEl          = root.querySelector('.caf-kh-std__qty-val');
    var qtyBtns           = root.querySelectorAll('.caf-kh-std__qty-btn');
    var totalValEl        = root.querySelector('.caf-kh-std__total-val');
    var selectedDelivery  = '通常便（10営業日出荷）';
    var selectedQuantity  = 1;
    var productVariants   = [];
    fetch('/products/keyholder-standard.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { productVariants = data.variants || []; })
      .catch(function () {});


    /* セクションブロックから付属金具データを読み込む */
    var attachmentOptions = [];
    var attachDataEl = document.getElementById('caf-kh-attach-data-' + root.dataset.sid);
    if (attachDataEl) {
      try { attachmentOptions = JSON.parse(attachDataEl.textContent); } catch (e) {}
    }

    var state = { tx: 0, ty: 0, scale: 1, rotate: 0 };
    var currentTemplate = null;
    var selectedAttachment = attachmentOptions[0] || null;
    var imgNatW = 0, imgNatH = 0, imgUrl = '';

    /* ---- viewBox計算（全形状がコンテナの制約方向に80%を占めるよう均一化） ---- */
    function computeEditorVB(tpl) {
      var R = 3 / 4;    // CSS aspect-ratio: 3/4 と同値
      var FILL = 0.80;  // 形状がコンテナの制約方向を占める割合
      var vb = tpl.viewBox;
      var cx = tpl.center.x;   // 印刷エリア中心（穴が中央に見えるよう）
      var cy = tpl.center.y;
      var w = Math.max(vb[2], tpl.areaH * R) / FILL;
      var h = w / R;
      return [cx - w / 2, cy - h / 2, w, h];
    }

    function computeChipVB(tpl) {
      var PAD = 0.08;
      var vb = tpl.viewBox;
      var pw = vb[2] * PAD, ph = tpl.areaH * PAD;
      var s = Math.max(vb[2] + pw * 2, tpl.areaH + ph * 2);
      var cx = tpl.center.x, cy = tpl.center.y;
      return [cx - s / 2, cy - s / 2, s, s];
    }

    /* ---- ユーティリティ ---- */
    function show(el) { if (el) el.classList.remove('is-hidden'); }
    function hide(el) { if (el) el.classList.add('is-hidden'); }

    function updateUI() {
      var hasImage = !!imgUrl;
      if (hasImage) {
        hide(uploadGuide);
        if (controls) controls.classList.add('is-visible');
        if (btnUpload) { btnUpload.textContent = '画像を変更'; btnUpload.classList.remove('is-secondary'); }
        if (svgWrap) svgWrap.classList.add('has-image');
        show(btnReset);
        show(btnConfirm);
      } else {
        show(uploadGuide);
        if (controls) controls.classList.remove('is-visible');
        if (btnUpload) { btnUpload.textContent = 'ファイルを選択'; btnUpload.classList.add('is-secondary'); }
        if (svgWrap) svgWrap.classList.remove('has-image');
        hide(btnReset);
        hide(btnConfirm);
      }
    }

    function updateSliderDisplays() {
      if (valScale)  valScale.textContent  = Math.round(state.scale * 100) + '%';
      if (valX)      valX.textContent      = Math.round(state.tx);
      if (valY)      valY.textContent      = Math.round(state.ty);
      if (valRotate) valRotate.textContent = Math.round(state.rotate) + '°';
      if (sliderScale)  sliderScale.value  = state.scale;
      if (sliderX)      sliderX.value      = state.tx;
      if (sliderY)      sliderY.value      = state.ty;
      if (sliderRotate) sliderRotate.value = Math.max(-180, Math.min(180, state.rotate));
    }

    function renderImage() {
      if (!currentTemplate || !imgUrl || !svgEl) return;
      var tpl = currentTemplate;
      var baseScale = Math.max(tpl.areaW / imgNatW, tpl.areaH / imgNatH);
      var total = baseScale * state.scale;
      var w = imgNatW * total;
      var h = imgNatH * total;
      var cx = tpl.center.x + state.tx;
      var cy = tpl.center.y + state.ty;
      var imgEl = svgEl.querySelector('image');
      if (imgEl) {
        imgEl.setAttribute('x', cx - w / 2);
        imgEl.setAttribute('y', cy - h / 2);
        imgEl.setAttribute('width', w);
        imgEl.setAttribute('height', h);
        imgEl.setAttribute('transform', 'rotate(' + state.rotate + ',' + cx + ',' + cy + ')');
      }
    }

    function applyTemplate(tpl) {
      if (!svgEl) return;
      currentTemplate = tpl;
      var vb = tpl.viewBox;

      /* 印刷エリア中心を基準にした均等viewBox */
      var pvb = computeEditorVB(tpl);
      svgEl.setAttribute('viewBox', pvb.join(' '));

      var cp = svgEl.querySelector('clipPath path');
      if (cp) cp.setAttribute('d', tpl.printAreaPath);

      var cl = svgEl.querySelector('.caf-kh-cut');
      if (cl) cl.setAttribute('d', tpl.cutLinePath);

      var bg = svgEl.querySelector('.caf-kh-bg');
      if (bg) {
        bg.setAttribute('x', pvb[0]); bg.setAttribute('y', pvb[1]);
        bg.setAttribute('width', pvb[2]); bg.setAttribute('height', pvb[3]);
        bg.setAttribute('fill', 'transparent');
      }

      if (sliderX) { sliderX.min = -tpl.areaW; sliderX.max = tpl.areaW; }
      if (sliderY) { sliderY.min = -tpl.areaH; sliderY.max = tpl.areaH; }

      if (sizeBadge) sizeBadge.textContent = tpl.size;

      if (imgUrl) renderImage();
    }

    /* ---- 形状チップ生成 ---- */
    if (strip) {
      TEMPLATES.forEach(function (tpl, idx) {
        var chip = document.createElement('div');
        chip.className = 'caf-kh-std__chip' + (idx === 0 ? ' is-active' : '');
        var tvb = computeChipVB(tpl);
        chip.innerHTML =
          '<div class="caf-kh-std__chip-preview">' +
            '<svg viewBox="' + tvb.join(' ') + '" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">' +
              '<path d="' + tpl.cutLinePath + '" fill="none" stroke="#a090d8" stroke-width="1.5" vector-effect="non-scaling-stroke"/>' +
            '</svg>' +
          '</div>' +
          '<p class="caf-kh-std__chip-name">' + tpl.name + '</p>';

        chip.addEventListener('click', function () {
          strip.querySelectorAll('.caf-kh-std__chip').forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          state = { tx: 0, ty: 0, scale: 1, rotate: 0 };
          applyTemplate(tpl);
          updateSliderDisplays();
        });

        strip.appendChild(chip);
      });
    }

    /* ---- 確定画面：金具チップ生成 ---- */
    function setAttachLabel(att) {
      if (!doneAttachLabel) return;
      if (!att) { doneAttachLabel.textContent = ''; return; }
      doneAttachLabel.textContent = att.label + (att.color ? '（' + att.color + '）' : '');
    }

    function renderDoneAttachChips() {
      if (!doneAttachStrip || attachmentOptions.length === 0) return;
      doneAttachStrip.innerHTML = '';
      selectedAttachment = attachmentOptions[0];
      setAttachLabel(selectedAttachment);
      attachmentOptions.forEach(function (att, idx) {
        var achip = document.createElement('button');
        achip.type = 'button';
        achip.className = 'caf-kh-std__attach-circle' + (idx === 0 ? ' is-active' : '');
        achip.setAttribute('aria-label', att.label + (att.color ? ' ' + att.color : ''));
        achip.innerHTML = att.image
          ? '<img src="' + att.image + '" alt="" loading="lazy">'
          : '<span class="caf-kh-std__attach-no-img">?</span>';
        achip.addEventListener('click', function () {
          doneAttachStrip.querySelectorAll('.caf-kh-std__attach-circle').forEach(function (c) { c.classList.remove('is-active'); });
          achip.classList.add('is-active');
          selectedAttachment = att;
          setAttachLabel(att);
          updatePriceDisplay();
        });
        doneAttachStrip.appendChild(achip);
      });
    }

    /* ---- 画像読み込み ---- */
    function loadImage(file) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        imgNatW = img.naturalWidth;
        imgNatH = img.naturalHeight;
        imgUrl  = url;
        state   = { tx: 0, ty: 0, scale: 1, rotate: 0 };

        var imgEl = svgEl ? svgEl.querySelector('image') : null;
        if (imgEl) imgEl.setAttribute('href', url);

        renderImage();
        updateSliderDisplays();
        updateUI();
      };
      img.src = url;
    }

    /* ---- ファイル入力 ---- */
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        if (this.files[0]) loadImage(this.files[0]);
      });
    }

    /* ---- アップロードガイド ---- */
    if (uploadGuide) {
      uploadGuide.addEventListener('click', function () { if (fileInput) fileInput.click(); });
    }

    /* ---- ドラッグ＆ドロップ ---- */
    if (svgWrap) {
      svgWrap.addEventListener('dragover', function (e) {
        e.preventDefault();
        if (!imgUrl && uploadGuide) uploadGuide.classList.add('is-dragover');
      });
      svgWrap.addEventListener('dragleave', function () {
        if (uploadGuide) uploadGuide.classList.remove('is-dragover');
      });
      svgWrap.addEventListener('drop', function (e) {
        e.preventDefault();
        if (uploadGuide) uploadGuide.classList.remove('is-dragover');
        var file = e.dataTransfer.files[0];
        if (file) loadImage(file);
      });
    }

    /* ---- ボタン ---- */
    if (btnUpload) {
      btnUpload.addEventListener('click', function () { if (fileInput) fileInput.click(); });
    }
    if (btnReset) {
      btnReset.addEventListener('click', function () {
        state = { tx: 0, ty: 0, scale: 1, rotate: 0 };
        renderImage(); updateSliderDisplays();
      });
    }
    if (btnConfirm) {
      btnConfirm.addEventListener('click', function () {
        renderToCanvas(function (canvas) {
          if (currentPhase === 'back') {
            backCanvas = canvas;
            backImgUrl = imgUrl; backNatW = imgNatW; backNatH = imgNatH;
            backState  = Object.assign({}, state);
            if (doneCanvasBackWrap) {
              doneCanvasBackWrap.innerHTML = '';
              canvas.style.width = '100%'; canvas.style.height = 'auto';
              doneCanvasBackWrap.appendChild(canvas);
            }
            show(doneBackSide);
            hide(btnAddBack); show(btnRemoveBack);
            updatePriceDisplay();
            /* フロント状態に戻す */
            currentPhase = 'front';
            imgUrl = frontImgUrl; imgNatW = frontNatW; imgNatH = frontNatH;
            state  = Object.assign({}, frontState);
            var imgElR = svgEl ? svgEl.querySelector('image') : null;
            if (imgElR) imgElR.setAttribute('href', frontImgUrl || '');
            if (frontImgUrl) renderImage();
            updateSliderDisplays();
            btnConfirm.textContent = 'この配置で確定 →';
            hide(btnSkipBack);
            var stripWrap = root.querySelector('.caf-kh-std__strip-wrap');
            if (stripWrap) stripWrap.style.display = '';
            hide(bodyEl); show(donePanel);
          } else {
            frontCanvas = canvas;
            frontImgUrl = imgUrl; frontNatW = imgNatW; frontNatH = imgNatH;
            frontState  = Object.assign({}, state);
            if (doneCanvasWrap) {
              doneCanvasWrap.innerHTML = '';
              canvas.style.width = '100%'; canvas.style.height = 'auto';
              doneCanvasWrap.appendChild(canvas);
            }
            hide(bodyEl); show(donePanel);
            renderDoneAttachChips();
            updatePriceDisplay();
          }
        });
      });
    }

    /* ---- 裏面追加・削除・スキップ ---- */
    if (btnAddBack) {
      btnAddBack.addEventListener('click', function() {
        currentPhase = 'back';
        imgUrl = backImgUrl || ''; imgNatW = backNatW || 0; imgNatH = backNatH || 0;
        state  = backImgUrl ? Object.assign({}, backState) : { tx: 0, ty: 0, scale: 1, rotate: 0 };
        var imgElB = svgEl ? svgEl.querySelector('image') : null;
        if (imgElB) imgElB.setAttribute('href', imgUrl || '');
        if (imgUrl) renderImage();
        updateSliderDisplays(); updateUI();
        btnConfirm.textContent = '裏面を確定 →';
        if (!isModalMode) show(btnSkipBack);
        /* 裏面編集中は形選択ストリップを非表示 */
        var stripWrap = root.querySelector('.caf-kh-std__strip-wrap');
        if (stripWrap) stripWrap.style.display = 'none';
        hide(donePanel); show(bodyEl);
      });
    }
    if (btnRemoveBack) {
      btnRemoveBack.addEventListener('click', function() {
        backCanvas = null;
        backImgUrl = ''; backNatW = 0; backNatH = 0;
        backState  = { tx: 0, ty: 0, scale: 1, rotate: 0 };
        if (doneCanvasBackWrap) doneCanvasBackWrap.innerHTML = '';
        hide(doneBackSide); show(btnAddBack); hide(btnRemoveBack);
        updatePriceDisplay();
      });
    }
    if (btnSkipBack) {
      btnSkipBack.addEventListener('click', function() {
        currentPhase = 'front';
        imgUrl = frontImgUrl; imgNatW = frontNatW; imgNatH = frontNatH;
        state  = Object.assign({}, frontState);
        var imgElS = svgEl ? svgEl.querySelector('image') : null;
        if (imgElS) imgElS.setAttribute('href', frontImgUrl || '');
        if (frontImgUrl) renderImage();
        updateSliderDisplays();
        btnConfirm.textContent = 'この配置で確定 →';
        hide(btnSkipBack);
        var stripWrapS = root.querySelector('.caf-kh-std__strip-wrap');
        if (stripWrapS) stripWrapS.style.display = '';
        hide(bodyEl); show(donePanel);
      });
    }
    if (btnOrder) {
      btnOrder.addEventListener('click', function () {
        /* ---- シミュレーターモード ---- */
        if (!frontCanvas) return;

        var shapeName = currentTemplate ? currentTemplate.name : '';
        var backOption = backCanvas ? 'あり' : 'なし';
        var variantId, cartQty;

        if (isModalMode) {
          /* モーダルモード: 商品ページの cafSimData を使用 */
          var simData = window.cafSimData || {};
          variantId = simData.variantId || parseInt(root.dataset.variant, 10);
          cartQty   = simData.qty || 1;
        } else {
          var matchedVariant = null;
          for (var i = 0; i < productVariants.length; i++) {
            var v = productVariants[i];
            if (v.option1 === selectedDelivery && v.option2 === shapeName && v.option3 === backOption) { matchedVariant = v; break; }
          }
          /* フォールバック：option3なし旧バリアント */
          if (!matchedVariant) {
            for (var fi = 0; fi < productVariants.length; fi++) {
              var fv = productVariants[fi];
              if (fv.option1 === selectedDelivery && fv.option2 === shapeName) { matchedVariant = fv; break; }
            }
          }
          variantId = matchedVariant ? matchedVariant.id : parseInt(root.dataset.variant, 10);
          cartQty   = selectedQuantity;
        }

        var att = selectedAttachment;

        btnOrder.disabled = true;
        btnOrder.textContent = 'アップロード中...';

        function doCartFetch(props) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: cartQty, properties: props }] })
          })
          .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function() { window.location.href = '/cart'; })
          .catch(function() {
            btnOrder.disabled = false; btnOrder.textContent = '注文に進む →';
            alert('カートへの追加に失敗しました。もう一度お試しください。');
          });
        }

        frontCanvas.toBlob(function(blob) {
          uploadDesignToCloudinary(blob, function(err, frontDesignUrl) {
            if (err) {
              btnOrder.disabled = false; btnOrder.textContent = '注文に進む →';
              alert('画像のアップロードに失敗しました。もう一度お試しください。');
              return;
            }
            renderDesignForPrint(frontImgUrl, frontState, frontNatW, frontNatH, function(frontDataUrl) {
            var frontSvgStr = generatePrintSVG(frontDataUrl);
            uploadSVGToCloudinary(frontSvgStr, function(svgErr, frontSvgUrl) {
              var props = {
                '形': shapeName,
                '裏面': backCanvas ? 'あり' : 'なし',
                'キーホルダーサイズ': currentTemplate ? currentTemplate.size : '',
                '付属金具': att ? att.label + (att.color ? '（' + att.color + '）' : '') : '未選択',
                '_表面デザイン': frontDesignUrl,
                '_表面入稿データ': frontSvgUrl || ''
              };
              if (!backCanvas) { doCartFetch(props); return; }
              backCanvas.toBlob(function(backBlob) {
                uploadDesignToCloudinary(backBlob, function(backErr, backDesignUrl) {
                  renderDesignForPrint(backImgUrl, backState, backNatW, backNatH, function(backDataUrl) {
                  var backSvgStr = generatePrintSVG(backDataUrl);
                  uploadSVGToCloudinary(backSvgStr, function(bsvgErr, backSvgUrl) {
                    props['_裏面デザイン']    = backDesignUrl || '';
                    props['_裏面入稿データ'] = backSvgUrl || '';
                    doCartFetch(props);
                  });
                  });
                });
              }, 'image/png');
            });
            }); /* renderDesignForPrint */
          });
        }, 'image/png');
      });
    }
    if (btnRedo) {
      btnRedo.addEventListener('click', function () {
        currentPhase = 'front';
        backCanvas = null; backImgUrl = ''; backNatW = 0; backNatH = 0;
        backState  = { tx: 0, ty: 0, scale: 1, rotate: 0 };
        if (doneCanvasBackWrap) doneCanvasBackWrap.innerHTML = '';
        hide(doneBackSide); show(btnAddBack); hide(btnRemoveBack);
        btnConfirm.textContent = 'この配置で確定 →';
        hide(btnSkipBack);
        show(bodyEl); hide(donePanel);
      });
    }

    /* ---- ドラッグ操作 ---- */
    if (svgWrap && svgEl) {
      var dragging = false;
      var dragPx = 0, dragPy = 0, dragTx = 0, dragTy = 0;
      var activePointers = new Set();

      function toSvgPt(clientX, clientY) {
        var pt = svgEl.createSVGPoint();
        pt.x = clientX; pt.y = clientY;
        return pt.matrixTransform(svgEl.getScreenCTM().inverse());
      }

      svgWrap.addEventListener('pointerdown', function (e) {
        activePointers.add(e.pointerId);
        if (!imgUrl || activePointers.size > 1) { dragging = false; return; }
        e.preventDefault();
        dragging = true;
        svgWrap.setPointerCapture(e.pointerId);
        var p = toSvgPt(e.clientX, e.clientY);
        dragPx = p.x; dragPy = p.y;
        dragTx = state.tx; dragTy = state.ty;
      });
      svgWrap.addEventListener('pointermove', function (e) {
        if (!dragging || activePointers.size > 1) return;
        var p = toSvgPt(e.clientX, e.clientY);
        state.tx = dragTx + (p.x - dragPx);
        state.ty = dragTy + (p.y - dragPy);
        renderImage(); updateSliderDisplays();
      });
      svgWrap.addEventListener('pointerup', function (e) {
        activePointers.delete(e.pointerId);
        if (activePointers.size === 0) dragging = false;
      });
      svgWrap.addEventListener('pointerleave', function (e) {
        activePointers.delete(e.pointerId);
        if (activePointers.size === 0) dragging = false;
      });

      svgWrap.addEventListener('wheel', function (e) {
        if (!imgUrl) return;
        e.preventDefault();
        state.scale = Math.max(0.1, Math.min(20, state.scale * (e.deltaY < 0 ? 1.12 : 0.88)));
        renderImage(); updateSliderDisplays();
      }, { passive: false });

      /* ---- 2本指ジェスチャー（ピンチ＆回転） ---- */
      var pinchStartDist = 1, pinchStartScale = 1;
      var pinchStartAngle = 0, pinchStartRotate = 0;
      var pinchStartMidX = 0, pinchStartMidY = 0;
      var pinchStartTx = 0, pinchStartTy = 0;

      function touchDist(t1, t2) {
        var dx = t2.clientX - t1.clientX, dy = t2.clientY - t1.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      function touchAngleDeg(t1, t2) {
        return Math.atan2(t2.clientY - t1.clientY, t2.clientX - t1.clientX) * 180 / Math.PI;
      }

      svgWrap.addEventListener('touchstart', function (e) {
        if (!imgUrl || e.touches.length !== 2) return;
        e.preventDefault();
        dragging = false;
        var t0 = e.touches[0], t1 = e.touches[1];
        pinchStartDist   = touchDist(t0, t1) || 1;
        pinchStartScale  = state.scale;
        pinchStartAngle  = touchAngleDeg(t0, t1);
        pinchStartRotate = state.rotate;
        pinchStartTx     = state.tx;
        pinchStartTy     = state.ty;
        var mid = toSvgPt((t0.clientX + t1.clientX) / 2, (t0.clientY + t1.clientY) / 2);
        pinchStartMidX = mid.x;
        pinchStartMidY = mid.y;
      }, { passive: false });

      svgWrap.addEventListener('touchmove', function (e) {
        if (!imgUrl || e.touches.length !== 2) return;
        e.preventDefault();
        var t0 = e.touches[0], t1 = e.touches[1];
        var dist  = touchDist(t0, t1);
        var angle = touchAngleDeg(t0, t1);
        var mid   = toSvgPt((t0.clientX + t1.clientX) / 2, (t0.clientY + t1.clientY) / 2);
        state.scale  = Math.max(0.1, Math.min(20, pinchStartScale * (dist / pinchStartDist)));
        state.rotate = pinchStartRotate + (angle - pinchStartAngle);
        state.tx     = pinchStartTx + (mid.x - pinchStartMidX);
        state.ty     = pinchStartTy + (mid.y - pinchStartMidY);
        renderImage(); updateSliderDisplays();
      }, { passive: false });
    }

    /* ---- スライダー ---- */
    if (sliderScale) {
      sliderScale.addEventListener('input', function () {
        state.scale = parseFloat(this.value);
        renderImage(); updateSliderDisplays();
      });
    }
    if (sliderX) {
      sliderX.addEventListener('input', function () {
        state.tx = parseFloat(this.value);
        renderImage(); updateSliderDisplays();
      });
    }
    if (sliderY) {
      sliderY.addEventListener('input', function () {
        state.ty = parseFloat(this.value);
        renderImage(); updateSliderDisplays();
      });
    }
    if (sliderRotate) {
      sliderRotate.addEventListener('input', function () {
        state.rotate = parseFloat(this.value);
        renderImage(); updateSliderDisplays();
      });
    }

    /* ---- 価格表示 ---- */
    function getVariantPrice(deliveryValue) {
      var shapeName = currentTemplate ? currentTemplate.name : '';
      var backOption = backCanvas ? 'あり' : 'なし';
      for (var i = 0; i < productVariants.length; i++) {
        var v = productVariants[i];
        if (v.option1 === deliveryValue && v.option2 === shapeName && v.option3 === backOption) {
          return Math.round(v.price / 100);
        }
      }
      /* option3なし（旧バリアント）のフォールバック */
      for (var j = 0; j < productVariants.length; j++) {
        var vj = productVariants[j];
        if (vj.option1 === deliveryValue && vj.option2 === shapeName) {
          return Math.round(vj.price / 100);
        }
      }
      return 0;
    }

    function updatePriceDisplay() {
      if (!totalValEl) return;
      var base = getVariantPrice(selectedDelivery);
      if (base <= 0) { totalValEl.textContent = '—'; return; }
      totalValEl.textContent = '¥' + (base * selectedQuantity).toLocaleString('ja-JP');
    }

    /* ---- 出荷予定日 ---- */
    function addBusinessDays(n) {
      var d = new Date();
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }
    function formatShipDate(d) {
      var days = ['日', '月', '火', '水', '木', '金', '土'];
      return (d.getMonth() + 1) + '月' + d.getDate() + '日(' + days[d.getDay()] + ') 出荷予定';
    }
    var normalSubEl  = root.querySelector('.caf-kh-delivery--normal .caf-kh-std__delivery-sub');
    var expressSubEl = root.querySelector('.caf-kh-delivery--express .caf-kh-std__delivery-sub');
    if (normalSubEl)  normalSubEl.textContent  = formatShipDate(addBusinessDays(10));
    if (expressSubEl) expressSubEl.textContent = formatShipDate(addBusinessDays(5));

    /* ---- 納期選択 ---- */
    deliveryOptions.forEach(function (lbl) {
      var radio = lbl.querySelector('input[type=radio]');
      if (radio) {
        radio.addEventListener('change', function () {
          deliveryOptions.forEach(function (l) { l.classList.remove('is-active'); });
          lbl.classList.add('is-active');
          selectedDelivery = radio.value;
          updatePriceDisplay();
        });
      }
    });

    /* ---- 数量 ---- */
    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.dataset.delta, 10);
        selectedQuantity = Math.max(1, selectedQuantity + delta);
        if (qtyValEl) qtyValEl.textContent = selectedQuantity;
        updatePriceDisplay();
      });
    });

    /* ---- 印刷用クリーンデザインPNG生成（背景なし・shape外透明） ---- */
    function renderDesignForPrint(iUrl, iState, iNatW, iNatH, cb) {
      if (!currentTemplate || !iUrl) { cb(null); return; }
      var tpl = currentTemplate;
      var tvb = tpl.viewBox;
      var TARGET_W = 1800;
      var canvas = document.createElement('canvas');
      canvas.width  = TARGET_W;
      canvas.height = Math.round(TARGET_W * tvb[3] / tvb[2]);
      var ctx = canvas.getContext('2d');
      var sx = canvas.width  / tvb[2];
      var sy = canvas.height / tvb[3];
      var userImg = new Image();
      userImg.onload = function() {
        ctx.save();
        ctx.translate(-tvb[0] * sx, -tvb[1] * sy);
        ctx.scale(sx, sy);
        ctx.save();
        ctx.clip(new Path2D(tpl.printAreaPath));
        var baseScale = Math.max(tpl.areaW / iNatW, tpl.areaH / iNatH);
        var total = baseScale * iState.scale;
        var iw = iNatW * total;
        var ih = iNatH * total;
        var cx = tpl.center.x + iState.tx;
        var cy = tpl.center.y + iState.ty;
        ctx.translate(cx, cy);
        ctx.rotate(iState.rotate * Math.PI / 180);
        ctx.drawImage(userImg, -iw / 2, -ih / 2, iw, ih);
        ctx.restore();
        ctx.restore();
        cb(canvas.toDataURL('image/png'));
      };
      userImg.onerror = function() { cb(null); };
      userImg.src = iUrl;
    }

    /* ---- 入稿用SVG生成 ---- */
    function generatePrintSVG(designDataUrl) {
      var tpl = currentTemplate;
      var tvb = tpl.viewBox;
      /* Illustrator SVGは72dpi（1pt=0.3528mm）で書き出されるため
         viewBoxのSVG単位から正確なmm値を計算する */
      var MM_PER_UNIT = 25.4 / 72;
      var sizeMatch = tpl.size.match(/(\d+)×(\d+)/);
      var physW = sizeMatch ? parseFloat(sizeMatch[1]) : 50;
      var physH = sizeMatch ? parseFloat(sizeMatch[2]) : 50;

      /* 白版を-0.2mmオフセット（中心点からスケールダウン） */
      var OFFSET_MM = 0.2;
      var scaleX = (tpl.areaW - 2 * OFFSET_MM * tpl.areaW / physW) / tpl.areaW;
      var scaleY = (tpl.areaH - 2 * OFFSET_MM * tpl.areaH / physH) / tpl.areaH;
      var cx = tpl.center.x, cy = tpl.center.y;
      var whiteTx = 'translate(' + cx + ',' + cy + ') scale(' + scaleX.toFixed(6) + ',' + scaleY.toFixed(6) + ') translate(' + (-cx) + ',' + (-cy) + ')';

      /* viewBoxを(0,0)原点に正規化してIllustratorのアートボードとずれを防ぐ */
      var ox = tvb[0], oy = tvb[1], vw = tvb[2], vh = tvb[3];
      var shift = 'translate(' + (-ox) + ',' + (-oy) + ')';
      var artW = (vw * MM_PER_UNIT).toFixed(3);
      var artH = (vh * MM_PER_UNIT).toFixed(3);

      return [
        '<?xml version="1.0" encoding="UTF-8"?>',
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
        '     viewBox="0 0 ' + vw + ' ' + vh + '" width="' + artW + 'mm" height="' + artH + 'mm">',
        '  <g transform="' + shift + '">',
        '    <g id="白版" transform="' + whiteTx + '"><path d="' + tpl.printAreaPath + '" fill="#000000"/></g>',
        '    <g id="デザイン">',
        '      <image xlink:href="' + (designDataUrl || '') + '"',
        '             x="' + ox + '" y="' + oy + '"',
        '             width="' + vw + '" height="' + vh + '"/>',
        '    </g>',
        '    <g id="カット"><path d="' + tpl.cutLinePath + '" fill="none" stroke="#ff0000" stroke-width="0.25"/></g>',
        '  </g>',
        '</svg>'
      ].join('\n');
    }

    function uploadSVGToCloudinary(svgStr, cb) {
      var blob = new Blob([svgStr], { type: 'image/svg+xml' });
      var fd = new FormData();
      fd.append('file', blob, 'keyholder-print.svg');
      fd.append('upload_preset', 'acrifact-keyholder');
      fetch('https://api.cloudinary.com/v1_1/dzmofagjd/image/upload', {
        method: 'POST',
        body: fd
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.secure_url) cb(null, data.secure_url);
        else cb(new Error('svg upload failed'));
      })
      .catch(cb);
    }

    /* ---- Cloudinary画像アップロード ---- */
    function uploadDesignToCloudinary(blob, cb) {
      var fd = new FormData();
      fd.append('file', blob, 'keyholder-design.png');
      fd.append('upload_preset', 'acrifact-keyholder');
      fetch('https://api.cloudinary.com/v1_1/dzmofagjd/image/upload', {
        method: 'POST',
        body: fd
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.secure_url) { cb(null, data.secure_url); }
        else { cb(new Error('no url')); }
      })
      .catch(function (err) { cb(err); });
    }

    /* ---- Canvas書き出し（Canvas 2D で直接描画） ---- */
    function renderToCanvas(cb) {
      if (!currentTemplate || !imgUrl) return;
      var tpl = currentTemplate;
      var vb  = svgEl.viewBox.baseVal;
      /* 表示幅の3倍（420px × 3 = 1260px）で高解像度出力 */
      var TARGET_W = 1260;
      var canvas = document.createElement('canvas');
      canvas.width  = TARGET_W;
      canvas.height = Math.round(TARGET_W * vb.height / vb.width);
      var ctx = canvas.getContext('2d');
      var sx  = canvas.width  / vb.width;
      var sy  = canvas.height / vb.height;

      ctx.fillStyle = '#f5f3fc';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      var userImg = new Image();
      userImg.onload = function () {
        ctx.save();
        ctx.translate(-vb.x * sx, -vb.y * sy);
        ctx.scale(sx, sy);

        /* 印刷エリアを白で塗りつぶし */
        ctx.fillStyle = '#ffffff';
        ctx.fill(new Path2D(tpl.printAreaPath));

        /* 画像をクリップして描画 */
        ctx.save();
        ctx.clip(new Path2D(tpl.printAreaPath));
        var baseScale = Math.max(tpl.areaW / userImg.naturalWidth, tpl.areaH / userImg.naturalHeight);
        var total = baseScale * state.scale;
        var iw = userImg.naturalWidth  * total;
        var ih = userImg.naturalHeight * total;
        var cx = tpl.center.x + state.tx;
        var cy = tpl.center.y + state.ty;
        ctx.translate(cx, cy);
        ctx.rotate(state.rotate * Math.PI / 180);
        ctx.drawImage(userImg, -iw / 2, -ih / 2, iw, ih);
        ctx.restore();

        /* カットライン */
        ctx.strokeStyle = '#b8b0e8';
        ctx.lineWidth = 0.5;
        ctx.stroke(new Path2D(tpl.cutLinePath));

        ctx.restore();
        cb(canvas);
      };
      userImg.src = imgUrl;
    }

    /* ---- 初期化 ---- */
    applyTemplate(TEMPLATES[0]);
    updateUI();

    /* ---- モーダルモード設定 ---- */
    if (isModalMode) {
      var elDelivery = root.querySelector('.caf-kh-std__done-delivery');
      var elQty      = root.querySelector('.caf-kh-std__done-quantity');
      var elTotal    = root.querySelector('.caf-kh-std__done-total');
      var elAttach   = root.querySelector('.caf-kh-std__done-attach-section');
      if (elDelivery) elDelivery.style.display = 'none';
      if (elQty)      elQty.style.display = 'none';
      if (elTotal)    elTotal.style.display = 'none';
      if (elAttach)   elAttach.style.display = 'none';
      /* 裏面ボタンはモーダルでは常に非表示→両面時のみ表示 */
      if (btnAddBack)  hide(btnAddBack);
      if (btnSkipBack) hide(btnSkipBack);
      if (printMode === '両面') {
        show(btnAddBack);
        /* btnSkipBack は裏面編集モードに入った時に btnAddBack handler が show() する */
      }
    }
  }

  /* ----------------------------------------------------------
     エントリポイント
  ---------------------------------------------------------- */
  window.cafKhStdInit = init;
  document.querySelectorAll('.caf-kh-std').forEach(function (root) { init(root); });
})();
